"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expmDependencies = void 0;

var _dependenciesAbsGenerated = require("./dependenciesAbs.generated.js");

var _dependenciesAddGenerated = require("./dependenciesAdd.generated.js");

var _dependenciesIdentityGenerated = require("./dependenciesIdentity.generated.js");

var _dependenciesInvGenerated = require("./dependenciesInv.generated.js");

var _dependenciesMultiplyGenerated = require("./dependenciesMultiply.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var expmDependencies = {
  absDependencies: _dependenciesAbsGenerated.absDependencies,
  addDependencies: _dependenciesAddGenerated.addDependencies,
  identityDependencies: _dependenciesIdentityGenerated.identityDependencies,
  invDependencies: _dependenciesInvGenerated.invDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated.multiplyDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createExpm: _factoriesAny.createExpm
};
exports.expmDependencies = expmDependencies;